var render = function render(){var _vm=this,_c=_vm._self._c;return _c('disk-list',{attrs:{"hiddenColumns":['unused', 'guest', 'medium_type'],"hiddenFilterOptions":['guest_id', 'unused', 'brand', 'region'],"id":_vm.id,"getParams":_vm.getParams,"show-create-action":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }